module.exports = "/images/extra-search-and-rescue.svg?2278020c80cd898e5303f22cd5c4a4a4";